// Shared notifications bridge — NotificationPanel + self-loading
// NotificationWrapper from @symbo.ls/collab-features/notifications.
// Shared across editor + intranet via sharedLibraries.
//
// NotificationBell is owned by ./NotificationBell.js (the local
// Button-based badge component). This bridge does not re-export it —
// frank's duplicate-export scan would flag both files.

import { notifications } from '../collab-features/src/index.js'

export const NotificationPanel = notifications.NotificationPanel
export const NotificationWrapper = notifications.NotificationWrapper
